<div
    bsModal
    #createOrEditModal="bs-modal"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="createOrEditModal"
    aria-hidden="true"
    [config]="{ backdrop: 'static' }"
>
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <form #StockTakeForm="ngForm" novalidate (ngSubmit)="save()" autocomplete="off">
                <div class="modal-header">
                    <h4 class="modal-title">
                        <span>{{ l('EditStockTakeItem') }}</span>
                    </h4>

                    <button
                        type="button"
                        class="btn-close"
                        (click)="close()"
                        aria-label="Close"
                        [disabled]="saving"
                    ></button>
                </div>
                <div class="modal-body">

                    <div class="row mt-3">
                        <div class="col-md-7">
                            <div class="form-group">
                                <label for="StockTakeDetail_ReferenceNo">{{ l('Code') }}</label>
                                <input type="text" id="stockTakeDetail_ProductCode"
                                       class="form-control" [(ngModel)]="stockTakeDetail.productCode" name="ProductCode" disabled="disabled" />
                            </div>
                        </div>
                        <div class="col-md-7">
                            <div class="form-group">
                                <label for="StockTakeDetail_ReferenceNo">{{ l('ProductName') }}</label>
                                <input type="text" id="stockTakeDetail_ProductName" disabled="disabled"
                                       class="form-control" [(ngModel)]="stockTakeDetail.productName" name="ProductName" />
                            </div>
                        </div>

                        <div class="col-md-7">
                            <div class="form-group">
                                <label for="StockTakeDetail_UnitName">{{ l('UnitName') }}</label>
                                <input type="text" id="stockTakeDetail_UnitName" disabled="disabled"
                                       class="form-control" [(ngModel)]="stockTakeDetail.unitName" name="UnitName" />
                            </div>
                        </div>
                        <div class="col-md-7">
                            <div class="form-group">
                                <label for="StockTakeDetail_SystemQty">{{ l('SystemQty') }}</label>
                                <input type="text" id="stockTakeDetail_SystemQty" disabled="disabled"
                                       class="form-control" [(ngModel)]="stockTakeDetail.systemQty" name="SystemQty" />
                            </div>
                        </div>
                        <div class="col-md-7">
                            <div class="form-group">
                                <label for="StockTakeDetail_PhysicalQty">{{ l('PhysicalQty') }}</label>
                                <input type="text" id="stockTakeDetail_PhysicalQty"
                                       class="form-control" name="PhysicalQty" [(ngModel)]="stockTakeDetail.physicalQty" />
                            </div>
                        </div>
                    </div>



                </div>
                <div class="modal-footer">
                    <button [disabled]="saving" type="button" class="btn btn-danger" (click)="close()">
                        {{ l('Cancel') }}
                    </button>
                    <button
                        type="submit"
                        class="btn btn-primary blue"
                        [disabled]="!StockTakeForm.form.valid"
                        [buttonBusy]="saving"
                        [busyText]="l('SavingWithThreeDot')"
                    >
                        <i class="fa fa-save"></i>
                        <span>{{ l('Save') }}</span>
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
